export default function dispatchEvent(type, data) {
  try {
    let iframe = document.getElementById('botIframe');
    iframe.contentWindow.postMessage(JSON.stringify({ type, data }), '*');
  } catch (err) {}
}
